import { SharedUiColorName } from '@/shared/ui/theming';
import { PluralizePipe } from '@/utils/i18n/pluralize.pipe';
import { ChangeDetectionStrategy, Component, type OnInit, inject } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslatePipe } from '@ngx-translate/core';
import type { SupplierWithMissingInvoices } from '../../../../interfaces/SuppliersMissingInvoices.interface';
import { SharedUiColoredTextColorDirective } from '../../../../libs/shared/ui/theming/lib/colors/shared-ui-color.directives';
import { DashboardingProvider } from '../../../../providers/dashboarding.provider';
import { InvoiceProvider } from '../../../../providers/invoice/invoice.provider';
import { LegacyWidgetCode } from '../../../../providers/rights.constants';
import { TrackingService } from '../../../../providers/tracking/tracking.service';
import { WidgetSize } from '../../../../providers/widgets.contants';
import { Page, RoutingService } from '../../../../services/routing/routing.service';
import { AbstractWidgetClass } from '../../AbstractWidget.class';
import { MiniWidgetIconCardComponent } from '../mini-widget-icon-card/mini-widget-icon-card';

@UntilDestroy()
@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./widget-mini-missing-invoices.scss'],
    selector: 'widget-mini-missing-invoices',
    templateUrl: 'widget-mini-missing-invoices.html',
    imports: [MiniWidgetIconCardComponent, SharedUiColoredTextColorDirective, TranslatePipe, PluralizePipe]
})
export class WidgetMiniMissingInvoicesComponent extends AbstractWidgetClass<null, void> implements OnInit {
    private _routingService = inject(RoutingService);
    private _dashboardingProvider = inject(DashboardingProvider);
    private _invoiceProvider = inject(InvoiceProvider);
    private _mixpanel = inject(TrackingService);

    size = WidgetSize.THIRD;

    missingInvoicesCount!: number;
    loading: boolean = true;
    statusColor: SharedUiColorName = SharedUiColorName.NEUTRAL;

    ngOnInit() {
        this._dashboardingProvider
            .getSelectedNodeId$()
            .pipe(untilDestroyed(this))
            .subscribe(classificationNodeId => {
                this.loading = true;

                this._invoiceProvider
                    .getSuppliersMissingInvoicesByBuilding$(
                        {
                            deliveryPointsFilters: {
                                isDynamicSelectionEnabled: true,
                                classificationNodeId,
                                universeIds: null
                            },
                            supplierIds: null
                        },
                        'name',
                        true
                    )
                    .then((missingInvoices: SupplierWithMissingInvoices[]) => {
                        this.loading = false;

                        // Mixpanel tracking
                        this._mixpanel.widgetViewed(LegacyWidgetCode.WDGT_MINI_MISSING_INVOICES, {
                            classificationNodeId,

                            count: missingInvoices.reduce((acc, item) => item.missingInvoiceCount + acc, 0)
                        });

                        this.missingInvoicesCount = missingInvoices.reduce((acc, item) => item.missingInvoiceCount + acc, 0);
                        if (this.missingInvoicesCount > 0) {
                            this.statusColor = SharedUiColorName.FAILURE;
                        } else {
                            this.statusColor = SharedUiColorName.SUCCESS;
                        }
                    });
            });
    }

    goToMissingInvoicesPage() {
        this._routingService.goTo(Page.SUPPLIERS_MISSING_INVOICES, {});
    }
}
